import { formatContractDateShort } from '../../utils/contractStatusUtils';
function presentationStatus(step, phase, completionStep) {
    if (completionStep !== 'cards' || phase !== 'complete')
        return step.state;
    if (step.id === 'cards')
        return 'current';
    if (step.id === 'completed')
        return 'pending';
    return step.state;
}
function timelineIcon(status) {
    if (status === 'completed')
        return 'checkCircle';
    if (status === 'current')
        return 'status';
    return 'circle';
}
export function buildBenefitMigrationTimeline(snapshot, completionStep) {
    return snapshot.steps.map(step => {
        const status = presentationStatus(step, snapshot.phase, completionStep);
        return {
            id: step.id,
            titleKey: `benefits.migration.timeline.${step.id}`,
            status,
            date: status === 'completed' && step.completedAt ? formatContractDateShort(step.completedAt) : null,
            icon: timelineIcon(status),
        };
    });
}
